import { useContext, useEffect, useRef } from "react";
import { CustomModal, Typography } from "get-life-storybook-ts";
import numberFormat from "../../../../utils/Utils";
import { I18nContext } from "../../../../context/i18n.context";
import "./css/upgradeCapitalModal.scss";

export default function UpgradeCapitalModal(props) {
  const { upGradedOpen, handleUpgradedClose, capitalsByTrait } = props;
  const {
    state: { translate },
  } = useContext(I18nContext);

  const modalRef = useRef(null);
  const wasOpenRef = useRef(false);

  useEffect(() => {
    if (upGradedOpen && !wasOpenRef.current) {
      modalRef.current?.handleShowPortal();
      wasOpenRef.current = true;
    } else if (!upGradedOpen && wasOpenRef.current) {
      modalRef.current?.handleClosePortal();
      wasOpenRef.current = false;
    }
  }, [upGradedOpen]);

  const deathCapital = capitalsByTrait?.DEATH ?? 0;

  const ModalTitle = (
    <div className="upsell-v3__upgradeModal-titleWrap">
      <span className="upsell-v3__upgradeModal-badge">
        {translate("newUpsell.v3.upgradeModal.badge")}
      </span>
      <Typography
        variant="H3"
        weight="700"
        text={translate("newUpsell.v3.upgradeModal.title")}
      />
    </div>
  );

  const ModalBody = (
    <div className="upsell-v3__upgradeModal">
      <Typography
        variant="Body"
        text={translate("newUpsell.v3.upgradeModal.description")}
        className="upsell-v3__upgradeModal-description"
      />
      <div className="upsell-v3__upgradeModal-capital">
        {numberFormat(deathCapital, "capital")}
      </div>
      <Typography
        variant="BodySmall"
        text={translate("newUpsell.v3.upgradeModal.footnote")}
        className="upsell-v3__upgradeModal-footnote"
      />
    </div>
  );

  const ModalActions = {
    showBoth: false,
    preventClose: true,
    buttonInfo: {
      primary: {
        label: translate("newUpsell.v3.upgradeModal.cta"),
        onClick: () => {
          modalRef.current?.handleClosePortal();
          wasOpenRef.current = false;
          handleUpgradedClose();
        },
      },
    },
  };

  return (
    <CustomModal
      ref={modalRef}
      ModalTitle={ModalTitle}
      ModalBody={ModalBody}
      ModalActions={ModalActions}
      fitContent
      closeModalCallback={() => {
        wasOpenRef.current = false;
        handleUpgradedClose();
      }}
    />
  );
}
